import { useQuery } from '@tanstack/react-query';
import { Partner } from '../../models/partner.ts';
import { fetchPartner } from '../../api/partner.ts';

export default function usePartner(id: string) {
  const response = useQuery<{ data: Partner }>({
    queryKey: ['partner', id],
    queryFn: () => fetchPartner(id),
  });
  const { data, ...rest } = response;
  return { partner: data?.data, ...rest };
}
